<template>
  <div>
    <resource-form :endpoint="endpoint" :method="method" :rules="rules" :schema="schema" :model="subscriptionTypeModel"
                   :width="900" :open_button="false"
                   @close="subscriptionTypeModel = {}" ref="resourceForm">
      <template #title>{{ 'app.pages.subscription_types' | trans }}</template>
      <template #form="{ resource }">
        <v-flex xs4 v-if="resource.id">
          <v-text-field v-model="resource.id"
                        required
                        disabled
                        :label="'app.id' | trans"
          ></v-text-field>
        </v-flex>
        <v-flex xs8>
          <v-text-field v-model="resource.name"
                        :label="'app.name' | trans"
                        required
                        :rules="rules.name"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 v-if="resource.id !== 30">
          <v-text-field v-model="resource.duration"
                        :label="'app.duration' | trans"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 v-if="resource.id !== 30">
          <v-text-field v-model="resource.extra_duration"
                      :label="'app.extra_duration' | trans"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 v-if="resource.id !== 30">
          <v-text-field v-model="resource.price"
                        :label="'app.price' | trans"
                        :rules="rules.price"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 v-if="resource.id !== 30">
          <v-text-field v-model="resource.role_to_assign"
                        :label="'app.type' | trans"
                        disabled
          ></v-text-field>
        </v-flex>
      </template>
    </resource-form>
  </div>
</template>
<script>
import has from "lodash/has";
import {trans} from "../../../app";

export default {
  props: {
    model: Object,
  },
  data: () => ({
    subscriptionTypeModel: null,
    schema: {
      name: null,
      roles: [],
    },
    rules: {
      name: [
        v => !!v || trans('validation.required', {'attribute': trans('app.name')}),
        v => v && v.length <= 255 || trans('validation.max.string', {
          attribute: trans('app.name'),
          max: 255,
        }),
        v => v && v.length >= 1 || trans('validation.min.string', {
          attribute: trans('app.name'),
          min: 1,
        }),
      ],
      price: [
        v => v && v >= 0 || trans('validation.min.numeric', {
          attribute: trans('app.price'),
          min: 0,
        }),
      ]
    },
  }),
  watch: {
    model(val) {
      this.subscriptionTypeModel = val;
    },
  },

  computed: {
    method() {
      return has(this.model, 'id') ? 'PATCH' : 'POST';
    },
    endpoint() {
      if (has(this.model, 'id')) {
        return `/administrator/subscription_types/${this.model.id}`;
      }

      return '/administrator/subscription_types';
    },
  },
};
</script>
